import savePrioritizeSettings from '../utils/savePrioritizeSettings';
import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import type CopilotPrioritizeSettings from '../types/CopilotPrioritizeSettings';
import defaultCopilotPrioritizeSettings from '../types/defaultCopilotPrioritizeSettings';
import getStore from '../store/store';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';

const onUpdatePrioritizeSettingsMutator: (
    mailboxInfo: MailboxInfo,
    prioritizeSettings: Partial<CopilotPrioritizeSettings>
) => void = mutatorAction(
    'onUpdatePrioritizeSettings',
    (mailboxInfo: MailboxInfo, prioritizeSettings: Partial<CopilotPrioritizeSettings>): void => {
        const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
        const existing =
            getStore().copilotPrioritizeSettingsStoreMap.get(accountKey)?.settings ??
            defaultCopilotPrioritizeSettings;

        savePrioritizeSettings(mailboxInfo, { ...existing, ...prioritizeSettings });
    }
);

export default onUpdatePrioritizeSettingsMutator;
